<template>
  <div v-if="optionChain">
    <v-toolbar
    color="white"
    flat
      tabs
    >
      <v-toolbar-title>Options Chain</v-toolbar-title>

      <template v-slot:extension>
        <v-tabs
          v-model="tab"
          grow
        >
          <v-tabs-slider ></v-tabs-slider>

          <v-tab
           v-for="expiration in expirations"
        :key="expiration"

        ripple
          >
            {{ expiration }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item
          v-for="expiration in expirations"
        :key="expiration"
      >
        <v-card flat>
          <v-data-table
            :loading="isLoading"
            :headers="headers"
            :pagination.sync="pagination"
            disable-initial-sort
            :items="groupedChain(expiration)"
            flat
        >
            <template v-slot:items="props">
              <td :class="inTheMoneyClass(props.item.callItm)">
                <p class="my-0">{{ props.item.callBid }}</p>
                <small>Size: {{props.item.callBidSize}}</small>
              </td>
            <td :class="inTheMoneyClass(props.item.callItm)">
              <p class="my-0">{{ props.item.callAsk }}</p>
              <small>Size: {{props.item.callAskSize}}</small>
            </td>
            <td class="grey lighten-2 text-xs-center">
              <p class="my-0">{{ props.item.strike }}</p>
            </td>
            <td :class="inTheMoneyClass(props.item.putItm)">
              <p class="my-0">{{ props.item.putBid }}</p>
              <small>Size: {{props.item.putBidSize}}</small>
            </td>
            <td :class="inTheMoneyClass(props.item.putItm)">
              <p class="my-0">{{ props.item.putAsk }}</p>
              <small>Size: {{props.item.putAskSize}}</small>
            </td>
            </template>
        </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>


<script>
export default {
  props: {
    optionChain: {
      type: Object,
    },
    quote: {
      type: Object,
    },
  },
  methods: {
    inTheMoneyClass(itm) {
      return {
        blue: itm,
        'lighten-4': itm,
        'text-xs-right': true,
      };
    },
    isInTheMoney(strike, optionType) {
      const strikeParsed = Math.ceil(parseFloat(strike));

      if (this.quote) {
        if (optionType === 'call' && this.quote.last > strikeParsed) {
          return true;
        }

        if (optionType === 'put' && this.quote.last <= strikeParsed) {
          return true;
        }
      }


      return false;
    },
    getOptionsForIndex(index) {
      this.getOptions(this.expirations[index]);
    },
    groupBy(list, key) {
      return list.reduce((rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);// eslint-disable-line
        return rv;
      }, {});
    },
    groupedChain(expiration) {
      if (this.optionChain) {
        const toReturn = [];

        const groupedByStrike = this.groupBy(this.optionChain[expiration], 'strike');
        Object.keys(groupedByStrike).forEach((strike) => {
          const strikeGroup = groupedByStrike[strike];
          const toPush = {
            strike: parseFloat(strike),
            callBid: null,
            callBidSize: null,
            callAsk: null,
            callAskSize: null,
            callOi: null,
            putBid: null,
            putBidSize: null,
            putAsk: null,
            putAskSize: null,
            putOi: null,
            optionType: '',
            callItm: false,
            putItm: false,
          };

          if (strikeGroup.length) {
            const call = strikeGroup.find(o => o.option_type === 'call');
            const put = strikeGroup.find(o => o.option_type === 'put');

            if (call) {
              toPush.callBid = call.bid;
              toPush.callBidSize = call.bidsize;
              toPush.callAsk = call.ask;
              toPush.callAskSize = call.asksize;
              toPush.callOi = call.open_interest;
              toPush.optionType = 'call';
              toPush.callItm = this.isInTheMoney(strike, 'call');
            }

            if (put) {
              toPush.putBid = put.bid;
              toPush.putBidSize = put.bidsize;
              toPush.putAsk = put.ask;
              toPush.putAskSize = put.asksize;
              toPush.putOi = put.open_interest;
              toPush.optionType = 'put';
              toPush.putItm = this.isInTheMoney(strike, 'put');
            }
            toReturn.push(toPush);
          }
        });
        return toReturn.sort((a, b) => {
          if (a.strike < b.strike) {
            return -1;
          }
          if (a.strike > b.strike) {
            return 1;
          }
          return 0;
        });
      }
      return [];
    },
  },
  computed: {
    expirations() {
      if (this.optionChain) {
        return Object.keys(this.optionChain).sort((a, b) => {
          const dateA = new Date(a);
          const dateB = new Date(b);

          if (dateA < dateB) {
            return -1;
          }
          if (dateA > dateB) {
            return 1;
          }

          return 0;
        });
      }
      return [];
    },

  },
  data() {
    return {
      isLoading: false,
      tab: null,
      pagination: {
        rowsPerPage: -1,
      },
      headers: [
        { text: 'Call Bid', value: 'callBid', sortable: false },
        { text: 'Call Ask', value: 'callAsk', sortable: false },
        { text: 'Strike', value: 'strike', sortable: false },
        { text: 'Put Bid', value: 'putBid', sortable: false },
        { text: 'Put Ask', value: 'putAsk', sortable: false },
      ],
    };
  },
};
</script>
